
const mathText = {

    coords: function (a) {
        return '(' + a.x + ';' + a.y + ')'
    },

    pointName: function (a) {
        return '<span style="color: ' + a.color + ';">' + a.name + '</span>'
    },

    pointX: function (a) {
        return mathText.pointName(a) + '.x'
    },

    pointY: function (a) {
        return mathText.pointName(a) + '.y'
    },

    point: function (a) {
        return mathText.pointName(a) + mathText.coords(a)
    },

    pointsDistance: function (a, b) {
        return mathText.pointName(a) + mathText.pointName(b)
    },

    vectorName: function (v) {
        return '<span style="color: ' + v.color + ';">VECTOR(' + v.name + ')</span>'
    },

    vector: function (v) {
        return mathText.vectorName(v) + mathText.coords(v)
    },

    dotProduct: function (u, v) {
        return mathText.vectorName(u) + '.' + mathText.vectorName(v)
    }

}


export default mathText

